import { render, staticRenderFns } from "./GerenciarEmendasFederais.vue?vue&type=template&id=29971cfa&scoped=true"
import script from "./script.js?vue&type=script&lang=js&external"
export * from "./script.js?vue&type=script&lang=js&external"
import style0 from "./GerenciarEmendasFederais.vue?vue&type=style&index=0&id=29971cfa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29971cfa",
  null
  
)

export default component.exports